const header = document.querySelector("header#header__site");

if (header) {
  window.addEventListener(
    "scroll",
    () => {
      header.classList.toggle("scrolling", window.scrollY > 0);
    },
    { passive: true },
  );

  const menuBtn = header.querySelector("#menu-btn");
  const nav = header.querySelector(".header--left");

  if (menuBtn && nav) {
    menuBtn.innerHTML = `
          <button class="hamburger" aria-label="Toggle navigation" aria-expanded="false">
              <span></span>
              <span></span>
              <span></span>
          </button>
      `;

    const btn = menuBtn.querySelector<HTMLButtonElement>(".hamburger")!;

    btn.addEventListener("click", () => {
      const isOpen = nav.classList.toggle("nav--open");
      btn.setAttribute("aria-expanded", String(isOpen));
      btn.classList.toggle("is-active", isOpen);
    });
  }
}
